import React, { useContext ,useEffect} from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";

import ProgressButtons from "../ProgressButtons";
import languageList from "../../../data/languageList";


const R9HomeLanguage = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    setLanguageToEnglish,
    formData: {
      firstName,
      firstLanguage,
      homeLanguage,
      languageSpokenByParentsToStudent,
      languageSpokenByAdultsAtHome,
    },
    onFormDataChange,
    pass: { homelanguage },
  } = registrationContext;

  const homeLanguage1 =
    firstLanguage !== "" &&
    homeLanguage !== "" &&
    languageSpokenByParentsToStudent !== "" &&
    languageSpokenByAdultsAtHome !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <div className="sub-form">
        <h2 className="">
          Home Language Survey <span>(8/15)</span>
          <hr />
        </h2>
        <div className="group">
          <div className="item">
            <div className="btn-container1">
              <div
                onClick={setLanguageToEnglish}
                className=" btn btn-l4l-green "
              >
                Set all to English
              </div>
            </div>
          </div>
          <div>
            <div className="item">
              <div className="asterisk-group">
                <h3>
                  What Is {firstName === "" ? "the Student" : firstName}'s First
                  Language?
                </h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>

              <select
                name="firstLanguage"
                value={firstLanguage}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border: homelanguage
                    ? "1px solid #ccc;"
                    : firstLanguage !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              >
                <option value="">Please Select </option>
                {languageList.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>
                  What Language Is Spoken at{" "}
                  {firstName === "" ? "the Student" : firstName}'s Home?
                </h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="homeLanguage"
                value={homeLanguage}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border: homelanguage
                    ? "1px solid #ccc;"
                    : homeLanguage !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              >
                <option value="">Please Select </option>
                {languageList.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>
                  What Language Is Spoken by Parent/Guardian to{" "}
                  {firstName === "" ? "the Student" : firstName} ?
                </h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="languageSpokenByParentsToStudent"
                value={languageSpokenByParentsToStudent}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border: homelanguage
                    ? "1px solid #ccc;"
                    : languageSpokenByParentsToStudent !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              >
                <option value="">Please Select </option>
                {languageList.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>
                  What Language Is Spoken by Adults at{" "}
                  {firstName === "" ? "the Student" : firstName}'s Home?
                </h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="languageSpokenByAdultsAtHome"
                value={languageSpokenByAdultsAtHome}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border: homelanguage
                    ? "1px solid #ccc;"
                    : languageSpokenByAdultsAtHome !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              >
                <option value="">Please Select </option>
                {languageList.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>
          </div>
        </div>
      </div>
      <ProgressButtons validation={homeLanguage1} name="homelanguage" />
    </>
  );
};

export default R9HomeLanguage;
